// extracted by mini-css-extract-plugin
export default {"description":"UploadECGData_description__bCg+B","fileSelect":"UploadECGData_fileSelect__YRcJf"};